var map = {
	"./1.svg": 786,
	"./2.svg": 787,
	"./3.svg": 788,
	"./4.svg": 789,
	"./5.svg": 790,
	"./6.svg": 791,
	"./7.svg": 792,
	"./8.svg": 793,
	"./9.svg": 794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 785;